import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	pageHeading: {
		id: 'fastshift.organizations-list-page.page-heading',
		defaultMessage: 'Organizations',
		description: 'Page heading for fastshift organizations list page',
	},
	pageDescription: {
		id: 'fastshift.organizations-list-page.page-description',
		defaultMessage: 'Select an organization to review its migration readiness signals.',
		description:
			'Page description for fastshift organizations list page to select an organization to review its migration readiness signals',
	},
	emptyTitle: {
		id: 'fastshift.organizations-list-page.empty-title',
		defaultMessage: 'No organizations found',
		description: 'Supporting title shown when the customer domain has no organizations',
	},
	emptyDescription: {
		id: 'fastshift.organizations-list-page.empty-description',
		defaultMessage: 'No organizations are associated with this domain.',
		description: 'Supporting info text shown when the customer domain has no organizations',
	},
	loadingLabel: {
		id: 'fastshift.organizations-list-page.loading-label',
		defaultMessage: 'Loading',
		description: 'Label shown when the organizations list is loading',
	},
	errorDescription: {
		id: 'fastshift.organizations-list-page.error-description',
		defaultMessage: "We're unable to load this page right now.",
		description: 'Supporting info text shown when the organizations list fails to load',
	},
});
